import Section from "components/Section";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import NotFound from "./NotFound";
import SectionTitle from "./SectionTitle";
import { GAME_LIST } from "utils/content";
import Games from "pages/Games";

const GamesContainer = (): JSX.Element => {
  const param = useParams();

  const currentGame: { title: string; path: string } | undefined =
    useMemo(() => {
      const game = GAME_LIST[param.game ?? ""];
      if (game) return game;
      return undefined;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  if (!currentGame) return <NotFound />;

  return (
    <>
      <Section className="min-h-screen gap-16" id="game-container">
        <SectionTitle className="text-primary !text-xl !w-full !text-left">
          {currentGame.title}
        </SectionTitle>

        <iframe
          title={currentGame.title}
          src={currentGame.path}
          style={{ width: "100%", height: "100vh", border: 0 }}
          allow="autoplay; fullscreen; gamepad"
        />
      </Section>
      <Games title="More Games..." reloadOnGameChange />
    </>
  );
};
export default GamesContainer;
